var ModalHelper = (function () {
    function ModalHelper() {
    }
    ModalHelper.prototype.show = function (idModal, canIclose) {
        if (canIclose === void 0) { canIclose = true; }
        if (canIclose == false) {
            $('#' + idModal).modal('show'); //display something
            //...
            // if you don't want to lose the reference to previous backdrop
            $('#' + idModal).modal('hide');
            $('#' + idModal).data('bs.modal', null); // this clears the BS modal data
            //...
            // now works as you would expect
            $('#' + idModal).modal({ backdrop: 'static', keyboard: false });
        }
        else {
            $('#' + idModal).modal('show');
        }
    };
    ModalHelper.prototype.hide = function (idModal) {
        $('#' + idModal).modal('hide');
    };
    return ModalHelper;
}());
export { ModalHelper };
